import gql from 'graphql-tag';






export const updateCommentQuery = gql`
  mutation UpdateComment($commentId: String!, $input: CommentInput!) {
    updateComment(input: $input, commentId: $commentId) {
      commentId
      resourceId
      parentId
      content
      metadata
      isResolved
      updatedAt
      createdByUser {
        userId
        firstName
        lastName
        email
        imageUrl
      }
      children {
        commentId
        parentId
        content
        metadata
        isResolved
        updatedAt
        createdByUser {
          userId
          firstName
          lastName
          email
          imageUrl
        }
      }
    }
  }
`;

const updateComment = () => ({
  mutation: updateCommentQuery,
  module: 'comments',
  buildVariables: (
  { commentId, input }) => (
  {
    input,
    commentId
  })
});

export default updateComment;